/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Discount_UnknownInputs */



/**
* | output |
* | --- |
* | "Discount not recorded for these periods" |
*
* @param {Partner_Billing_Board_Discount_UnknownInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_discount_unknown = /** @type {((inputs?: Partner_Billing_Board_Discount_UnknownInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Discount_UnknownInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Rabatt für diese Zeiträume nicht erfasst")
	return /** @type {LocalizedString} */ ("Discount not recorded for these periods")
});